import { Card, Divider } from "@mui/material";
import AttachmentViewer from "../AttachmentViewer/AttachmentViewer";
import { useSelector } from "react-redux";
import CoreSpinner from "../CoreSpinner/CoreSpinner";
import { useGetSingleDocumentIdQuery } from "../../../../features/api/admin/gestisciDocumentiApi";
import CoreButton from "../CoreButton/CoreButton";
import { t } from "i18next";
import CoreInputField from "../CoreInputField/CoreInputField";
import { useEffect, useState } from "react";
import CoreDialog from "../CoreDialog/CoreDialog";
import ImageGallery from "../AttachmentViewer/ImageGallery";
import PDFViewer from "../AttachmentViewer/PDFViewer";
import { toast } from "react-toastify";
import { ROLE } from "../../../../utils/constants/profiles";
import { useGetDocumentByIdQuery } from "../../../../features/api/user/gestisciDocumentiApi";

const CoreDuplicate = ({
  docId,
  payload,
  onClose,
  onSuccess,
  createDocument,
  deleteDocument,
}) => {
  const role = useSelector((state) => state.app.role);
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const [singleDoc, setSingleDoc] = useState();
  const [editName, setEditName] = useState(false);
  const [formData, setFormData] = useState();
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [filesDrop, setFilesDrop] = useState();
  const [isProcessing, setIsProcessing] = useState(false);

  const { data: dataAdmin, isLoading: loadingAdmin } =
    useGetSingleDocumentIdQuery(docId, {
      skip: !docId || role === ROLE.USER,
    });

  const { data: dataUser, isLoading: loadingUser } = useGetDocumentByIdQuery(
    docId,
    {
      skip: !docId || role !== ROLE.USER,
    }
  );

  useEffect(() => {
    if (role !== ROLE.USER && dataAdmin) setSingleDoc(dataAdmin);
    if (role === ROLE.USER && dataUser) setSingleDoc(dataUser);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataAdmin, dataUser]);

  useEffect(() => {
    if (payload) {
      setFormData({ ...payload });
      setFilesDrop({
        url: role === ROLE.USER ? payload?.s3FilesPath[0] : payload.S3FilePath,
        extension: payload?.documents[0]?.extension,
      });
    }
  }, [payload, role]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleOverride = async () => {
    const toastId = toast.loading(t("Processing"));
    setIsProcessing(true);

    try {
      // Prima elimina il documento esistente
      const deleteRes = await deleteDocument(singleDoc?.Data?.id);

      if (deleteRes?.data?.Result !== 1) {
        toast.update(toastId, {
          render: t("DocsNotLoaded"),
          type: "error",
          isLoading: false,
          autoClose: 1500,
        });
        return;
      }

      const body = { ...payload };
      const responseCreateDoc = await createDocument(body);

      if (responseCreateDoc?.data?.Result !== 1) {
        toast.update(toastId, {
          render: t("DocsNotLoaded"),
          type: "error",
          isLoading: false,
          autoClose: 1500,
        });
        return;
      }

      toast.update(toastId, {
        render: `${t("DocsLoaded")}`,
        type: "success",
        isLoading: false,
        autoClose: 1500,
      });
      onSuccess?.(responseCreateDoc.data.Data?.id, {
        ...body,
        files: responseCreateDoc.data.Data?.files,
      });
      onClose();
    } catch (error) {
      console.error(error);
      toast.update(toastId, {
        render: t("DocsNotLoaded"),
        type: "error",
        isLoading: false,
        autoClose: 1500,
      });
    } finally {
      setIsProcessing(false);
    }
  };

  const handleSave = async () => {
    const toastId = toast.loading(t("Processing"));
    setIsProcessing(true);

    try {
      const body = { ...payload, name: formData.name };
      const responseCreateDoc = await createDocument(body);

      if (responseCreateDoc?.data?.Result !== 1) {
        toast.update(toastId, {
          render: t("DocsNotLoaded"),
          type: "error",
          isLoading: false,
          autoClose: 1500,
        });
        return;
      }

      toast.update(toastId, {
        render: `${t("DocsLoaded")}`,
        type: "success",
        isLoading: false,
        autoClose: 1500,
      });
      onSuccess?.(responseCreateDoc.data.Data?.id, {
        ...body,
        files: responseCreateDoc.data.Data?.files,
      });
      onClose();
    } catch (error) {
      console.error(error);
      toast.update(toastId, {
        render: t("DocsNotLoaded"),
        type: "error",
        isLoading: false,
        autoClose: 1500,
      });
    } finally {
      setIsProcessing(false);
    }
  };

  if (loadingAdmin || loadingUser) {
    return <CoreSpinner />;
  }

  return (
    <div>
      <div className="flex items-center">
        <div className="w-full">
          <h3 className="m-0">{t("DocumentControl")}</h3>
          {editName ? (
            <div className="flex  items-center gap-4">
              <CoreInputField
                className="w-full"
                type="text"
                name="name"
                label={`${t("Edit")} ${t("Name")}`}
                value={formData.name}
                onChange={handleInputChange}
              />

              <CoreButton
                testo={t("Save")}
                onClick={handleSave}
                className={"btn-round bg-green-500 disabled:bg-green-100"}
                variant="contained"
              />
            </div>
          ) : (
            <p className="m-0 font-bold" style={{ color: colorPrimary }}>
              {singleDoc?.Data?.name}
            </p>
          )}
        </div>
        <div className="w-6/12 flex justify-end space-x-4">
          <Card
            className="flex justify-center items-center text-center"
            sx={{
              maxWidth: "25rem",
              borderRadius: "20px",
              padding: 2,
            }}
            elevation={2}
          >
            <div className="flex- flex-col">
              <h3 className="m-0">{t("Actions")}</h3>
              <div>
                <CoreButton
                  testo={`Mantieni`}
                  className={"text-primary"}
                  onClick={() => setEditName(!editName)}
                />
                <CoreButton
                  disabled={
                    singleDoc?.Data?.practiceDocuments.length > 0 ||
                    isProcessing
                  }
                  testo={t("Overwrite")}
                  className={
                    singleDoc?.Data?.practiceDocuments.length > 0
                      ? "text-gray"
                      : "text-orange-600 "
                  }
                  onClick={() => setOpenDeleteDialog(true)}
                />
                <CoreButton
                  testo={t("Annulla")}
                  className={"text-red-600 "}
                  onClick={onClose}
                />
              </div>
              {singleDoc?.Data?.practiceDocuments.length > 0 && (
                <>
                  <Divider />
                  <p className="text-xs font-semibold text-red-600">
                    {t("NotExistingDocument")}
                  </p>
                </>
              )}
            </div>
          </Card>
        </div>
      </div>
      <Divider className="p-2" />
      <div className="flex justify-between">
        <h3>{t("DocPreview")}</h3>
      </div>
      <div className="flex w-full space-x-4">
        <div className="w-6/12">
          <p className="px-4 text-red-600  font-semibold">{t("ExistingDoc")}</p>
          <AttachmentViewer files={singleDoc?.Data?.files} />
        </div>
        <div className="w-6/12">
          <p className="px-4 text-blue-600 font-semibold">{t("NewDocument")}</p>
          {filesDrop?.extension?.toLowerCase() === "pdf" ? (
            <PDFViewer url={filesDrop?.url} />
          ) : (
            <ImageGallery url={filesDrop?.url} />
          )}
        </div>
      </div>
      <CoreDialog
        open={openDeleteDialog}
        title={`${t("Overwrite")} ${t("ExistingDoc")}`}
        content={t("CheckExistingDocument")}
        negativeButton={t("No")}
        positiveButton={t("Yes")}
        handlePositive={handleOverride}
        closeDialog={() => setOpenDeleteDialog(false)}
      />
    </div>
  );
};

export default CoreDuplicate;
